import styled from "@emotion/styled";
import { padding } from "polished";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";

import ModuleRenderer from "../../ModuleRenderer";
import type { INavGroup } from "../../types";

const Heading = styled.h2(({ theme }) => ({
  ...theme.typography.BodySmallSB,
  color: theme.colors.content.tertiary,
  background: theme.colors.background.secondary,
  ...padding(theme.spacing.SML.xxsml, theme.spacing.SML.sml),
  margin: 0,
}));

interface Props {
  data: INavGroup;
}

export default function NavGroup({ data: { title, columns } }: Props) {
  return (
    <Container direction="column">
      {!title.hideOnMobile && <Heading>{title.text}</Heading>}
      {(columns || []).map((column) => (
        <ModuleRenderer key={column._key} span={1} modules={column.modules} />
      ))}
    </Container>
  );
}
